import React, { useMemo } from 'react';
import css from './VehicleImages.module.scss';
import AlfaRomeo from 'src/content/images/Makes/AlfaRomeo.png';
import AstonMartin from 'src/content/images/Makes/AstonMartin.png';
import Audi from 'src/content/images/Makes/Audi.png';
import AudiLanding from 'src/content/images/Makes/AudiWhite.png';
import Bentley from 'src/content/images/Makes/Bentley.png';
import BMWLanding from 'src/content/images/Makes/BMWLanding.png';
// import BMWMenu from 'src/content/images/Makes/BMWMenu.png';
import BMWroundelwhite from 'src/content/images/Makes/BMW-roundel-white.png';
import BMWColorSensitive from 'src/content/images/Makes/BMWColorSensitive.png';
import Bugatti from 'src/content/images/Makes/Bugatti.png';
import Cadillac from 'src/content/images/Makes/Cadillac.png';
import CadillacSmall from 'src/content/images/Makes/Cadillac-White-sm.png';
import CadillacLanding from 'src/content/images/Makes/Cadillac-White.png';
import Chevrolet from 'src/content/images/Makes/Chevy.png';
import ChevroletWhite from 'src/content/images/Makes/Chevy-WHT.png';
import Chrysler from 'src/content/images/Makes/Chrysler.png';
import Dodge from 'src/content/images/Makes/Dodge.png';
import Dodge2 from 'src/content/images/Makes/Dodge2.png';
import DodgeLanding from 'src/content/images/Makes/DodgeLanding.png';
import Ferrari from 'src/content/images/Makes/Ferrari.png';
import Fiat from 'src/content/images/Makes/Fiat.png';
import Ford from 'src/content/images/Makes/Logo-Ford-Signature-BLU-TR.png';
import FordWhite from 'src/content/images/Makes/Logo-Ford-Signature-WHT-TR.png';
import Genesis from 'src/content/images/Makes/GEN_Wing_negative.png';
import GenesisBlack from 'src/content/images/Makes/GEN_Wing_positive.png';
import Gmc from 'src/content/images/Makes/GMC.png';
import Honda from 'src/content/images/Makes/Honda.png';
import HondaWhite from 'src/content/images/Makes/HondaWhite.png';
import HondaCA from 'src/content/images/Makes/HondaCA.png';
import Hummer from 'src/content/images/Makes/Hummer.png';
import Hyundai from 'src/content/images/Makes/HyundaiBlue.png';
import HyundaiHorizontal from 'src/content/images/Makes/HyundaiBlueHorizontal.png';
import Infiniti from 'src/content/images/Makes/INFINITISymbolBlack.png';
import InfinitiWhite from 'src/content/images/Makes/INFINITISymbolWhite.png';
import InfinitiLand from 'src/content/images/Makes/INFINITILogoWhite.png';
import JaguarLight from 'src/content/images/Makes/Jaguar-Logo-WHT.png';
import JaguarDark from 'src/content/images/Makes/Jaguar-Logo-GRY.png';
import Jeep from 'src/content/images/Makes/Jeep.png';
import JeepLanding from 'src/content/images/Makes/JeepLanding.png';
import Kia from 'src/content/images/Makes/Kia.svg';
import KiaWhite from 'src/content/images/Makes/KiaLanding.svg';
import Lamborghini from 'src/content/images/Makes/Lamborghini.png';
import LandRoverLight from 'src/content/images/Makes/LandRover-Logo-2D-WHT.png';
import LandRoverDark from 'src/content/images/Makes/LandRover-Logo-2D-BLU.png';
import Lexus from 'src/content/images/Makes/Lexus.png';
import LexusWhite from 'src/content/images/Makes/Lexus-Logo-White.svg';
import LexusMonogram from 'src/content/images/Makes/LexusMonogram.png';
import LexusMonogramWhite from 'src/content/images/Makes/LexusMonogram-White.png';
// import LexusLandingPage from 'src/content/images/Makes/LexusLandingPage.svg';
import LexusMenu from 'src/content/images/Makes/Lexus-logo-2D-vertical-black.png';
import Lincoln from 'src/content/images/Makes/Lincoln.png';
import LincolnADA from 'src/content/images/Makes/LincolnADA.png';
import Maserati from 'src/content/images/Makes/Maserati.png';
import Mazda from 'src/content/images/Makes/Mazda.png';
import MazdaLanding from 'src/content/images/Makes/Mazda-Landing.png';
import Mercedes from 'src/content/images/Makes/Mercedes-Benz-minimal.png';
// import MercedesLanding from 'src/content/images/Makes/Mercedes-Benz-wordmark.pn
import Mini from 'src/content/images/Makes/Mini.png';
import Nissan from 'src/content/images/Makes/Nissan-BLK.jpg';
import NissanLanding from 'src/content/images/Makes/Nissan-WHT-Transparent.png';
import NissanMenu from 'src/content/images/Makes/Nissan-BLK-Transparent.png';
import Porsche from 'src/content/images/Makes/Porsche-Logo-BLK.png';
// import PorscheADA from 'src/content/images/Makes/PorscheADA.png';
import Ram from 'src/content/images/Makes/Ram.png';
import RamLanding from 'src/content/images/Makes/RamLanding.png';
import RamLight from 'src/content/images/Makes/RamLight.png';
import Smart from 'src/content/images/Makes/Smart.png';
import Subaru from 'src/content/images/Makes/Subaru-logo-vertical-white.png';
import SubaruNonLP from 'src/content/images/Makes/Subaru-logo-vertical-black.png';
import Suzuki from 'src/content/images/Makes/Suzuki.png';
// import Toyota from 'src/content/images/Makes/Toyota.png';
import Toyota from 'src/content/images/Makes/ToyotaLogo.png';
import ToyotaLanding from 'src/content/images/Makes/ToyotaLogoWhite.png';
// import ToyotaSPM from 'src/content/images/Makes/ToyotaSPM.png';
import ToyotaSPM2 from 'src/content/images/Makes/ToyotaSPM2.png';
import ToyotaSPMLanding from 'src/content/images/Makes/ToyotaSPMWhite.png';
import VolksWagenThumb from 'src/content/images/Makes/Volkswagen.png';
import VolkswagenLanding from 'src/content/images/Makes/VW-Logo-White.png';
import VolkswagenMenu from 'src/content/images/Makes/VW-Logo-DarkBlue.png';
import Volvo from 'src/content/images/Makes/Volvo.png';
import Acura from 'src/content/images/Makes/Acura.png';
import AcuraWhite from 'src/content/images/Makes/AcuraWhite.png';
import AcuraLanding from 'src/content/images/Makes/AcuraLanding.png';
import AcuraCanada from 'src/content/images/Makes/AcuraCanada.png';
import AcuraCanadaWhite from 'src/content/images/Makes/AcuraCanadaWhite.png';
import Buick from 'src/content/images/Makes/Buick.png';
import BuickWhite from 'src/content/images/Makes/Buick-White.png';
import BuickLanding from 'src/content/images/Makes/Buick-Landing.png';
import CDJR from 'src/content/images/Makes/CDJR.png';
import CDJRWhite from 'src/content/images/Makes/CDJR-logos-WHT-TR.png';
import CDJRgif from 'src/content/images/Makes/CDJR-rotating-logos-BLK.gif';
import GM from 'src/content/images/Makes/GM.svg';
import classNames from 'classnames';
import { checkSpecTheme } from 'src/helpers/OEMHelper/OEMHelper';
import { ServiceDocsData, SpecData } from 'src/models';
import { THEME } from 'src/constants/ThemeNames';
// import { lowerCase } from 'lodash';

interface IProps {
    make: string;
    type?: 'menuLogo' | 'thumb' | 'landingLogo' | undefined;
    background?: string;
    theme?: string;
    specData?: SpecData;
    serviceDocsData?: ServiceDocsData;
    colorSensitiveEnabled?: boolean;
    setHasImage?: (hasImage: boolean) => void;
}

const VehicleMakeImages = (props: IProps) => {
    const specsTheme = props.specData?.oemTheme ?? '';
    const serviceSpecsTheme = props.serviceDocsData?.theme ?? '';
    const specTheme = checkSpecTheme(specsTheme || serviceSpecsTheme);
    let {background} = props;
    if ((props.theme === 'hyundai') || (props.theme === 'lexus')) {
        background = 'light';
    }
    if ((props.theme === 'mazda' || props.theme === 'mercedesBenz' || props.theme === 'genesis') && !props.colorSensitiveEnabled) {
        background = 'light';
    }
    if (!props.colorSensitiveEnabled && props.theme === 'infiniti') {
        background = 'light';
    }
    if (!props.colorSensitiveEnabled && props.theme === 'nissan') {
        background = 'light';
    }
    // if we were passed dark and the theme is acura then force over to light unless we
    // have color sensitive enabled.
    if (background === 'dark' && !props.colorSensitiveEnabled) {
        if (props.theme === 'acura') {
            background = 'light';
        }
    }
    // Audi's make cards are dark, so makes with a white logo use it there.
    const audiDark = props.theme === THEME.AUDI && background === 'dark';

    const makeImage = useMemo(() => {
        let make = props.make;
        if ((make === 'Honda' || make === 'honda') && props.theme ==='honda-CA'){
            make='honda-CA';
        }
        if ((make === 'Acura' || make === 'acura') && props.theme ==='acura-CA'){
            make='acura-CA';
        }

        const transLit = make.toLowerCase();
        switch (transLit) {
            // case 'Acura':
            case 'acura-ca':
                if (props.colorSensitiveEnabled && background === 'dark') {
                    return AcuraCanadaWhite;
                }
                switch (props.type) {
                    case 'landingLogo':
                        return AcuraCanadaWhite;
                    case 'menuLogo':
                        if (props.colorSensitiveEnabled) {
                            return AcuraCanadaWhite;
                        }

                        return AcuraCanadaWhite;
                    default:
                        return AcuraCanada;
                }
            case 'acura':
                if ((props.theme === 'colorSensitive' || props.colorSensitiveEnabled) && background === 'dark') {
                    return AcuraWhite;
                }
                if (background === 'dark' && props.theme !== 'bmw') {
                    return AcuraWhite;
                }
                switch (props.type) {
                    case 'landingLogo':
                        return AcuraLanding;
                    case 'menuLogo':
                        return AcuraWhite;
                    default:
                        return Acura;
                }
            case 'acura color sensitive':
                switch (props.type) {
                    case 'landingLogo':
                        return AcuraWhite;
                    default:
                        return Acura;
                }

            // case 'Alfa Romeo':
            // case 'AlfaRomeo':
            case 'alfa romeo':
            case 'alfaromeo':
                return AlfaRomeo;

            // case 'Aston Martin':
            // case 'AstonMartin':
            case 'aston martin':
            case 'astonmartin':
                return AstonMartin;

            // case 'Audi':
            case 'audi':
                if (props.type === 'landingLogo' || audiDark) {
                    return AudiLanding;
                } else {
                    return Audi;
                }
            case 'bentley':
                return Bentley;

            // case 'BMW':
            case 'bmw':
            case 'bmwi':
                if (props.type === 'menuLogo' || audiDark) {
                    return BMWroundelwhite;
                }
                if (background) {
                    return BMWColorSensitive;
                } else {
                    return BMWLanding;
                }
            case 'bmw color sensitive':
                return BMWColorSensitive;
            case 'buick':
                if (props.type === 'landingLogo') {
                    return BuickLanding;
                }
                if (background === 'dark' && props.theme !== 'bmw') {
                    return BuickWhite;
                } else {
                    return Buick;
                }
            case 'bugatti':
                return Bugatti;

            // case 'Cadillac':
            case 'cadillac':
                if (props.type === 'landingLogo') {
                    return CadillacLanding;
                }
                if (background === 'dark' && props.theme !== 'bmw') {
                    return CadillacSmall;
                } else {
                    return Cadillac;
                }
            case 'cjdr':
                if (props.type === 'menuLogo') {
                    return CDJRgif;
                } else if (props.type === 'landingLogo') {
                    return CDJRWhite;
                } else {
                    return CDJR;
                }
            // case 'Chevrolet':
            case 'chevrolet':
                if ((background === 'dark' && (props.theme !== 'chevrolet' && props.theme !== 'bmw')) ||
                props.type === 'landingLogo') {
                    return ChevroletWhite;
                } else {
                    return Chevrolet;
                }
            // case 'Chrysler':
            case 'chrysler':
            case 'chrysler canada':
                return Chrysler;

            // case 'Dodge':
            case 'dodge':
                // return Dodge;
                if (props.type === 'menuLogo') {
                    return Dodge;
                }
                if (background === 'dark' && props.theme !== 'bmw') {
                    return DodgeLanding;
                }
                if (background === 'light' || props.theme === 'bmw') {
                    return Dodge2;
                }

                return DodgeLanding;

            case 'ferrari':
                return Ferrari;

            case 'fiat':
                return Fiat;

            // case 'Ford':
            case 'ford':
            case 'ford truck':
            case 'ford canada':
                if (props.type === 'menuLogo' || background === 'light' || (props.theme === 'bmw' && !props.colorSensitiveEnabled)){
                    return Ford;
                }

                return FordWhite;

            case 'genesis':
                if (props.type === 'menuLogo' && props.theme !== 'colorSensitive'){
                    return Genesis;
                } else if (props.type === 'landingLogo'){
                    return Genesis;
                } else if (background === 'dark' || (props.theme === 'colorSensitive' && background === 'dark')){
                    return Genesis;
                } else {
                    return GenesisBlack;
                }
            case 'gm':
                return GM;
            // case 'GMC':
            case 'gmc':
                return Gmc;

            // case 'Honda':
            case 'honda-ca':
                return HondaCA;
            case 'honda':
            case 'honda mtc/pp/pe':
                if (audiDark) {
                    return HondaWhite;
                }
                switch (props.type) {
                    case 'landingLogo':
                        return HondaWhite;
                    default:
                        return Honda;
                }
            case 'honda color sensitive': {
                return specTheme === 'honda-CA' ? HondaWhite : Honda;
            }

            case 'hummer':
                return Hummer;

            // case 'Hyundai':
            case 'hyundai':
                switch (props.type) {
                    case 'landingLogo':
                        return HyundaiHorizontal;
                    default:
                        return Hyundai;
                }

            // case 'Infiniti':
            // case 'INFINITI':
            case 'infiniti':
                if (props.type === 'landingLogo') {
                    return InfinitiLand;
                }
                if ((background === 'dark' && props.theme !== 'bmw')) {
                    return InfinitiWhite;
                }

                return Infiniti;
            case 'infiniti color sensitive':
                switch (props.type) {
                    case 'landingLogo':
                        return InfinitiWhite;
                    default:
                        return Infiniti;
                }

            // case 'Jaguar':
            case 'jaguar':
            case 'jag':
            // case 'JAG':
                if ((props.type === 'landingLogo' || background === 'dark') && props.theme !== 'bmw') {
                    return JaguarLight;
                } else {
                    return JaguarDark;
                }

            // case 'Jeep':
            case 'jeep':
                // return Jeep;
                if (props.type === 'menuLogo') {
                    return Jeep;
                } else {
                    return JeepLanding;
                }

            // case 'Kia':
            case 'kia':
                if (background === 'dark') {
                    return KiaWhite;
                } else {
                    return Kia;
                }

            case 'lamborghini':
                return Lamborghini;

            // case 'Land Rover':
            // case 'LandRover':
            case 'land rover':
            case 'landrover':
                if ((props.type === 'landingLogo' || background === 'dark') && props.theme !== 'bmw') {
                    return LandRoverLight;
                } else {
                    return LandRoverDark;
                }

            // case 'Lexus':
            case 'lexus':
                if (background === 'dark' && props.theme !== 'bmw'){
                    return LexusWhite;
                }
                if (props.type === 'menuLogo') {
                    return LexusMenu;
                }

                return Lexus;
                // if (props.type === 'menuLogo') {
                //     return LexusMenu;
                // } else {
                //     return LexusLandingPage;
                // }

            case 'lexusmonogram':
                return LexusMonogram;
            case 'lexus monogram color sensitive':
                if (props.type === 'landingLogo' || background === 'dark') {
                    return LexusMonogramWhite;
                } else {
                    return LexusMonogram;
                }

            // case 'Lincoln':
            case 'lincoln':
                if (background === 'dark' && props.theme !== 'bmw') {
                    return LincolnADA;
                }
                switch (props.type) {
                    case 'landingLogo':
                        return LincolnADA;
                    default:
                        return Lincoln;
                }

            case 'maserati':
                return Maserati;

            // case 'Mazda':
            case 'mazda':
            case 'mazda truck':
                if (props.type === 'landingLogo') {
                    return MazdaLanding;
                } else {
                    return Mazda;
                }

            case 'mercedes':
            case 'mercedes benz':
            case 'mercedes-benz':
            case 'mercedesbenz':
                switch (props.type){
                    case 'landingLogo':
                        return;
                    default:
                        return Mercedes;
                }

            // case 'Mini':
            // case 'MINI':
            case 'mini':
                return Mini;

            // case 'Nissan':
            case 'nissan':
                if (audiDark) {
                    return NissanLanding;
                }
                switch (props.type) {
                    case 'landingLogo':
                        return NissanLanding;
                    case 'menuLogo':
                        return NissanMenu;
                    default:
                        return Nissan;
                }
            // case 'Porsche':
            case 'porsche':
                return Porsche;
            case 'porsche color sensitive':
                return Porsche;

            // case 'Ram':
            case 'ram':
                if (props.type === 'landingLogo') {
                    return RamLanding;
                }
                if (background === 'dark' && props.theme !== 'bmw') {
                    return RamLight;
                } else {
                    return Ram;
                }

            case 'smart':
                return Smart;

            // case 'Subaru':
            case 'subaru':
                if ((props.type === 'landingLogo' || background === 'dark') && props.theme !== 'bmw') {
                    return Subaru;
                } else {
                    return SubaruNonLP;
                }

            case 'suzuki':
                return Suzuki;

            // case 'Toyota':
            case 'toyota':
                if (props.type === 'landingLogo') {
                    return ToyotaLanding;
                }
                if (background === 'dark' && (props.theme !== 'chevrolet') &&
                    (props.theme === 'colorSensitive' || props.colorSensitiveEnabled || audiDark)) {
                    return ToyotaLanding;
                } else {
                    return Toyota;
                }

            // case 'ToyotaSPM':
            case 'toyotaspm':

                if (props.type === 'landingLogo') {
                    return ToyotaSPMLanding;
                } else {
                    return ToyotaSPM2;
                }

            // case 'Volkswagen':
            case 'volkswagen':
            case 'vw canada':
                if (props.type === 'menuLogo') {
                    return VolkswagenMenu;
                } else if (props.type === 'thumb' && !audiDark) {
                    return VolksWagenThumb;
                } else if (props.type === 'landingLogo') {
                    return VolkswagenLanding;
                } else if (props.theme !== 'bmw' && background === 'dark') {
                    return VolkswagenLanding;
                } else {
                    return VolkswagenMenu;
                }

            case 'volvo':
                return Volvo;

            default:
                return '';
        }
    }, [props.make, props.theme, props.type, background, specTheme, props.colorSensitiveEnabled, audiDark]);

    if (makeImage && props.setHasImage) {
        props.setHasImage(true);
    }
    // const onImageLoad = useCallback((event: any) => {
    //     setWidth(event.target.offsetWidth);
    //     setHeight(event.target.offsetHeight);
    // }, []);

    const imageClasses = classNames(
        {
            [css.menuLogo]: props.type === 'menuLogo',
            [css.vehicleModelImage]: props.type === 'thumb',
            [css.landingLogo]: props.type === 'landingLogo',
            [css.vehicleImage]: !props.type,
            [css.toyMenuLogo]: props.type === 'menuLogo' && (props.make.toLowerCase() === 'toyota' ||
                props.make.toLowerCase() === 'toyotaspm'),
            [css.porscheLogo]: (props.type === undefined || props.type === 'thumb') &&
                props.make.toLowerCase() === 'porsche',
            [css.audiLogo]: props.type === 'landingLogo' && props.make === 'audi',
            // first part applies the red BG to the menu logo, second to the vehicle card
            [css.logoAreaHondaCA]: props.make === 'honda-CA' || (props.make === 'Honda' && props.theme === 'honda-CA'),
            [css.benzLogo]: props.make === 'mercedesBenz' || props.make === 'Mercedes-Benz',
            [css.buickLogo]: props.theme === 'buick' && props.type === 'landingLogo',
            [css.infinitiLogo]: props.theme === 'infiniti' && props.type === 'menuLogo',
            [css.genesisLogo]: props.theme === 'genesis' && props.type === 'landingLogo',
        },
    );

    return (
        <div id={'imageContainer_' + props.make} className={props.type === 'menuLogo' ?
            (specTheme === 'honda-CA' ? css.menuLogoAreaHCA : css.menuLogoArea) : ''}>
            <picture>
                { makeImage !== '' ?
                    <img src={makeImage} alt={props.make} className={imageClasses} />:
                    ''
                }
            </picture>
        </div>
    );
};

export default VehicleMakeImages;